import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchItemsMaster(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('purchase/vendors/items-master/list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteItemsMaster(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`purchase/items-master/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
